var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcel64 = function SvgExcel64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Excel_64_svg__a",
    x1: 5.56,
    x2: 26.441,
    y1: 13.916,
    y2: 50.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18884f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6631"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#185c37",
    d: "m39 26-24 6v25.333A2.667 2.667 0 0 0 17.667 60h42.666A2.667 2.667 0 0 0 63 57.333V46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21a366",
    d: "M39 4H17.667A2.666 2.666 0 0 0 15 6.667V18l24 14 12 5 12-5V18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#33c481",
    d: "M60.333 4H39v14h24V6.667A2.666 2.666 0 0 0 60.333 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#107c41",
    d: "M39 32h24v14H39zM15 18h24v14H15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.63v29.739a2 2 0 0 1-.045.451A2.61 2.61 0 0 1 30.378 51H15V16h15.378A2.62 2.62 0 0 1 33 18.63",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18.759V46.24a3.73 3.73 0 0 1-1.163 2.709A3.68 3.68 0 0 1 30.278 50H15V15h15.278A3.754 3.754 0 0 1 34 18.759",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18.651v27.7A2.63 2.63 0 0 1 30.378 49H15V16h15.378A2.63 2.63 0 0 1 33 18.651",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18.651v27.7A2.64 2.64 0 0 1 29.359 49H15V16h14.359A2.64 2.64 0 0 1 32 18.651",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    y: 16,
    fill: "url(#Excel_64_svg__a)",
    rx: 2.667
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.258 40.666 5.609-8.691-5.137-8.642h4.134l2.8 5.524q.387.786.532 1.172h.036q.277-.627.58-1.22l3-5.476h3.8l-5.27 8.594 5.4 8.739H19.7L16.466 34.6a5 5 0 0 1-.387-.809h-.049a3.8 3.8 0 0 1-.374.785l-3.336 6.09Z"
  })));
};
export default SvgExcel64;